import { ConfirmModal } from "@solomon-apps/shared/src/components/ui/confirm-modal";
import React, { useEffect } from "react";

import { useVerificationConsentStore } from "@/hooks/yaas/verificationConsentStore";
import { VERIFICATION_TRANSFER_SOL } from "@/services/yaas/verificationTransfer";

/**
 * Asks before the verification falls back to a small SOL transfer.
 * `useWalletVerification` raises the request through the consent store;
 * any surface that runs `VerifyOwnershipButton` mounts this once.
 * Unmounting declines a pending request so the verification never waits
 * on a modal that is gone.
 */
export function VerificationConsentModal(): React.ReactElement {
    const verificationConsent = useVerificationConsentStore();
    const { answer } = verificationConsent;
    useEffect(() => (): void => answer(false), [answer]);
    return (
        <ConfirmModal
            open={verificationConsent.request !== null}
            onOpenChange={(open): void => {
                if (!open) verificationConsent.answer(false);
            }}
            title="Verify with a small transfer"
            description={`Send ${VERIFICATION_TRANSFER_SOL} SOL to verify wallet ownership. A network fee also applies. No transfer is sent until you approve it in your wallet.`}
            confirmLabel="Continue to wallet"
            onConfirm={(): void => verificationConsent.answer(true)}
        />
    );
}
